import { IStuHoSoSinhVienViewModel } from "../../../model/respone/category/IStuHoSoSinhVienViewModel";
import { ILichThiSinhVienReducerData } from "../../reducer-model/tct/ILichThiSinhVienReducer";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
export interface ILichThiSinhVienActionTyesBase<T> {
    id: string,
    data: T
}
export const eLichThiSinhVienActionsObj = {
    ADD_NEW_TAB: {} as undefined | IStuHoSoSinhVienViewModel,
    REMOVE_TAB: "",
    UPDATE_TAB_DATA: {} as ILichThiSinhVienReducerData,
    CHANGEG_SELECTED_TAB: "",
    CHANGE_DOT_THI_ID: {} as number,


};

export const eLichThiSinhVienActionIds = generateActionTypeIds(eLichThiSinhVienActionsObj, "LICH_THI_SINH_VIEN");
export type ILichThiSinhVienActionTypes = IGenericActionType<typeof eLichThiSinhVienActionsObj, "LICH_THI_SINH_VIEN">;